<template>
  <Team_manager_adviser_bar_m></Team_manager_adviser_bar_m>
  <router-view></router-view>
</template>

<script>
import Team_manager_adviser_bar_m from "@/components/CN_mobile/team/Team_manager_adviser_bar_m";
export default {
  name: 'Team_manager_adviser_m',
  components: {Team_manager_adviser_bar_m,}
}

</script>

<style scoped>

</style>